export class Alert {
  message: string = '';
  detail: string = '';
  idkey: number | null = null;
  typeClass: string = '';
  bloquear: boolean = false;
  faltaCC: boolean = false;
  faltaCartaConducao: boolean = false;
  ComponenteName: string = '';
  AlertButon: string = '';
}
